module.exports = __webpack_public_path__ + "img/icon_arrowTurnBottom.160f3d3a.svg";